import React from 'react';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import adminRoutes from './config/adminRoutes';
import CanonicalSetter from './components/canonicalSetter';
import siteRoutes from './config/siteRoutes';


const App: React.FC = () => {
  
  const routes = [...siteRoutes, ...adminRoutes];
  const routing = useRoutes(routes);
    
  return routing;
};

const AppWrapper: React.FC = () => {
  return (
    <Router>
      <CanonicalSetter />
      <App />
    </Router>
    
  );
};

export default AppWrapper;